import React from 'react'
import { AuthRoutes } from '../features/auth/routes'
import { ApplicationRoutes } from '../features/application/routes'
export const authRoutes = [{ path: '/auth/*', element: <AuthRoutes/> }]
export const applicationRoutes = [...ApplicationRoutes]
